package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.sdk.currentSession
import com.ilussobsa.sdk.currentUser
import com.ilussobsa.utils.bought
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.locale.RenderSize
import com.lightningkite.kiteui.locale.renderDateToString
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.RecyclerViewPlacerVerticalGrid
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import com.lightningkite.serialization.notNull
import kotlinx.coroutines.launch
import kotlin.math.ceil

@Routable("/purchases")
class PurchasesScreen : Page {

    val purchasedQuery = remember {
        Query(
            condition<Vehicle> {
                Condition.And(
                    listOfNotNull(
                        condition { it.completion neq null },
                        condition { it.completion.notNull.sold eq true },
//                        condition { it.completion.notNull.winner.notNull eqNn currentUser()?._id }
                    )
                )
            },
            orderBy = sort { it.completion.notNull.at }
        )
    }

    override fun ViewWriter.render() = col {
        val toListen = remember {
            currentSession().vehicle.query(purchasedQuery())
        }
        val items = remember { toListen()() }
        val noPurchases = remember { items().isEmpty() }
        card - expanding - col {
            compact - row {
                centered - icon(Icon.bought, Strings.purchases)
                centered - h2(Strings.purchases)
            }
            expanding - frame {
                recyclerView {
                    ::shown{ !noPurchases() }
                    val columns = remember { ceil(AppState.windowInfo().width.viewUnits / 35.rem.viewUnits).toInt() }
                    ::placer {
                        RecyclerViewPlacerVerticalGrid(
                            columns = columns(),
                            ratio = 1.0
                        )
                    }
                    children(
                        items = items,
                        id = { it._id }
                    ) {
                        important - col {
                            row {
                                expanding - h3 {
                                    ::content{
                                        it().ymmt
                                    }
                                }
                                h3 {
                                    ::content{ it().completion?.price?.renderPriceInDollars() ?: "-" }
                                }
                            }
                            row {
                                compact - row {
                                    centered - CriticalSemantic.onNext - text(Strings.date)
                                    centered - text {
                                        ::content{
                                            it().completion?.at?.renderDateToString(
                                                RenderSize.Numerical
                                            ) ?: "-"
                                        }
                                    }
                                }
                                space()
                                compact - row {
                                    centered - CriticalSemantic.onNext - text(Strings.mileage2)
                                    centered - text { ::content{ it().odometer?.toCommaString() ?: Strings.noMileageInformation } }
                                }
                                expanding - space()
                                compact - row {
                                    val existingProxyBid = remember {
                                        vehicleRelationshipUpsertProp(it()._id, VehicleRelationship.path.autobid)
                                    }
                                    val proxyBid = Signal<Int?>(null)

                                    launch {
                                        proxyBid set existingProxyBid()()
                                    }

                                    ::shown{ proxyBid() != null }
                                    centered - CriticalSemantic.onNext - text(Strings.yourProxyBid)
                                    centered - text { ::content{ proxyBid()?.renderPriceInDollars() ?: "" } }
                                }
                            }
                            expanding - image {
                                scaleType = ImageScaleType.Crop
                                ::source { it().thumbnail?.let { ImageRemote(it.location) } }
                            }
                        }
                    }
                }
            }
            col {
                ::shown{ noPurchases() }
                nothingSelected("You have not purchased any vehicles yet.")
            }
        }
        space()
    }
}
